import axios from 'axios';
import { Globals } from '@/modules/Globals';
import { getServerErrorMessage } from '@/utils/error.utils';
import { HostToolError } from './tool-types';

const getErrorMessageFallback = (error: unknown): string => {
  if (
    error instanceof Error &&
    typeof error.message === 'string' &&
    error.message.trim()
  ) {
    return error.message;
  }
  if (typeof error === 'string' && error.trim()) return error.trim();
  return 'Request failed';
};

export const throwNormalizedApiError = (error: unknown): never => {
  const defaultMessage = getErrorMessageFallback(error);
  const message = getServerErrorMessage(error, { defaultMessage });

  // Preserve AxiosError shape for downstream tooling (status code, response, etc),
  // but ensure the message matches the server-provided error when available.
  if (axios.isAxiosError(error)) {
    error.message = message;
    throw error;
  }

  if (error instanceof Error) {
    error.message = message;
    throw error;
  }

  throw new HostToolError('API_ERROR', message);
};

export const axiosGetData = async <T>(url: string): Promise<T> => {
  try {
    const res = await axios.get<T>(url);
    return res.data;
  } catch (error) {
    return throwNormalizedApiError(error);
  }
};

export const runToolApiCall = async <T>(fn: () => Promise<T>): Promise<T> => {
  try {
    return await fn();
  } catch (error) {
    return throwNormalizedApiError(error);
  }
};

export function statsUrl(path: string) {
  return `${Globals.apiPath}/stats${path}`;
}

export function setIfDefined(
  qs: URLSearchParams,
  key: string,
  value: string | number | boolean | null | undefined
) {
  if (typeof value === 'undefined' || value === null) return;
  qs.set(key, typeof value === 'string' ? value : String(value));
}
